import SNIPER_EXT_1 from "./SNIPER_EXT_1";
export default {
  SNIPER_EXT_1,
};
